import React from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import * as actions from '../../actions/index';

import Header from '../Header/Header';

import './FullScreen.css';

const FullScreen = props => (
  <section className="fullScreen">
    {
      (props.data.title || props.data.subtitle || props.data.pretitle) &&
      <Header
        title={props.data.title}
        subtitle={props.data.subtitle}
        pretitle={props.data.pretitle}
        className="title"
        type="fullscreen"
      />
    }
    {
      props.data.image &&
      <img
        className={"fullScreen__image " + (props.data.style || '') }
        src={props.data.image.src}
        alt={props.data.image.alt}
      />
    }
    {
      props.data.video &&
      <video className="fullScreen__video" src={props.data.video.src} loop={props.data.video.loop} autoPlay style={{ objectFit: props.data.video.fit }}>
      </video>
    }
    {
      props.data.actions &&
      props.data.actions.length &&
      <div className="fullScreen__actions">
        {props.data.actions.map((action, aPos) => {
          const doAction = () => props.setModal(action.media);
          return (
            <button className="fullScreen__action" onClick={doAction} key={aPos}
              style={action.top ? {top: action.top+''} : null}>
              {action.text}
            </button>
          );
        })}
      </div>
    }
  </section>
);


function mapDispatchToProps(dispatch) {
  return {
    setModal: (index) => {
      dispatch(actions.setModal(index));
    },
  };
}

FullScreen.propTypes = {
  data: propTypes.object.isRequired,
};

export default connect(null, mapDispatchToProps)(FullScreen);




// WEBPACK FOOTER //
// ./src/components/FullScreen/FullScreen.js